import { EKycVerificationStatus } from '@exam-center/graphql';
import {
  CancelOutlinedIcon,
  CheckCircleOutlineRoundedIcon,
  DoNotDisturbOnOutlinedIcon,
  ErrorOutlineIcon,
  PendingOutlinedIcon,
  PendingActionsOutlined,
  Text,
} from '@shared/components';

interface ExamineeKycIconProps {
  status: EKycVerificationStatus;
}

export default function ExamineeKycIcon({ status }: Readonly<ExamineeKycIconProps>) {
  switch (status) {
    case EKycVerificationStatus.Approved:
      return (
        <CheckCircleOutlineRoundedIcon
          sx={(theme) => ({
            color: theme.palette.success.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    case EKycVerificationStatus.Rejected:
      return (
        <CancelOutlinedIcon
          sx={(theme) => ({
            color: theme.palette.error.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    case EKycVerificationStatus.InProgress:
      return (
        <PendingOutlinedIcon
          sx={(theme) => ({
            color: theme.palette.warning.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    case EKycVerificationStatus.PendingApproval:
      return (
        <PendingActionsOutlined
          sx={(theme) => ({
            color: theme.palette.info.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    case EKycVerificationStatus.Expired:
      return (
        <ErrorOutlineIcon
          sx={(theme) => ({
            color: theme.palette.error.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    case EKycVerificationStatus.NotRequired:
      return (
        <Text
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            textAlign: 'left',
          })}
        >
          {'  - '}
        </Text>
      );
    default:
      return (
        <DoNotDisturbOnOutlinedIcon
          sx={(theme) => ({
            color: theme.palette.grey[500],
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
  }
}
